import React, {useState} from "react";
import {NavLink, Route} from "react-router-dom";
import {
  useProfile,
  isProfileRoleTypeTags,
} from "../../components/ui";
import {
  ROLE_ADMINISTRATOR,
  ROLE_CLIENT,
  ROLE_DIRECTOR,
  ROLE_EMPLOYEE,
} from "../../config/constants";

function MenuRouting(props) {
  const { profile } = useProfile();
  const {setIsModalProfile} = props;

  const onChange = () => {
    if (!!props.onChange) {
      props.onChange()
    }
  }

  return (
    <>
      {isProfileRoleTypeTags(profile, [
        ROLE_ADMINISTRATOR,
        ROLE_DIRECTOR,
      ]) && (
        <ul className="Menu__list Menu__list_box">
          <li className="List__link">
            <NavLink className={"Link__text"} to={"/tickets"} onClick={() => onChange()}>
              Тикеты
              <div style={{
                fontSize: 12,
                opacity: .75
              }}>
                Задачи по улучшениям и ошибкам
              </div>
            </NavLink>
          </li>
        </ul>
      )}

      {isProfileRoleTypeTags(profile, [
        ROLE_ADMINISTRATOR,
        ROLE_DIRECTOR,
        ROLE_EMPLOYEE,
      ]) && (
        <ul className="Menu__list Menu__list_box">
          <li className="List__link">
            <NavLink className={"Link__text"} to={"/clients"} onClick={() => onChange()}>
              Клиенты
            </NavLink>
          </li>
          <li className="List__link">
            <NavLink className={"Link__text"} to={"/employees"} onClick={() => onChange()}>
              Сотрудники
            </NavLink>
          </li>
          {isProfileRoleTypeTags(profile, [ROLE_ADMINISTRATOR]) && (
            <li className="List__link">
              <NavLink className={"Link__text"} to={"/accounts"} onClick={() => onChange()}>
                Аккаунты
              </NavLink>
            </li>
          )}
        </ul>
      )}
    </>
  );
}

export default MenuRouting;
